// src/components/Shared/LogoutButton/LogoutButton.js

import React from 'react';
import Button from '../Button/Button';
import './LogoutButton.css'; // Specifika stilar om nödvändigt

function LogoutButton({ onLogout }) {
  const handleLogout = () => {
    localStorage.removeItem('access_token');
    onLogout();
  };

  return (
    <Button
      onClick={handleLogout}
      className="logout-button"
      style={{
        backgroundColor: '#dc3545',
        color: 'white',
      }}
    >
      Logga ut
    </Button>
  );
}

export default LogoutButton;
